import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardTrainingGroupsEdit = guard(groupRights.TrainingGroups)('edit');
export const guardTrainingGroupsWatch = guard(groupRights.TrainingGroups)('watch');
export const guardTrainingGroupsCreate = guard(groupRights.TrainingGroups)('create');
